import React from "react";
import { useFlipper } from "services/api/flipper";
import {
  Course,
  CurrentSemester,
  FormationDate,
  University,
  NotInUniversity,
  MainEducationType,
  IesPeriod,
  MainEducationStatus,
  IesEducationType,
} from "components/users/fields/academic";

const OldVersion = (props) => {
  const defaultValue = props.getValues?.("not_in_university")?.toString() || false;
  const [showAcademic, setShowAcademic] = React.useState(defaultValue !== "true");

  const handleChange = (value) => {
    setShowAcademic(value !== "true");
  }

  return (
    <>
      <div className="col-md-12">
        <NotInUniversity {...props} handleChange={handleChange} />
      </div>
      {showAcademic && <OldUniversityFields {...props} />}
    </>
  );
};

const OldUniversityFields = (props) => {
  return (
    <>
      <div className="col-md-12">
        <University {...props} required />
      </div>
      <div className="col-md-12">
        <Course {...props} required />
      </div>
      <div className="col-md-12">
        <CurrentSemester {...props} required />
      </div>
      <div className="col-md-12">
        <FormationDate {...props} required />
      </div>
    </>
  )
}

const NewVersion = (props) => {
  const defaultValue = props.getValues?.("main_education_type");
  const [mainEducationType, setMainEducationType] =
    React.useState(defaultValue);

  const handleChange = (value) => {
    setMainEducationType(value);
  };

  return (
    <>
      <div className="col-md-12">
        <MainEducationType {...props} handleChange={handleChange} />
      </div>
      {mainEducationType && mainEducationType !== "none" && (
        <NewUniversityFields {...props} mainEducationType={mainEducationType} />
      )}
    </>
  );
};

const NewUniversityFields = (props) => {
  const { mainEducationType } = props;

  const showIesAndCourse =
    mainEducationType !== "elementary_school" &&
    mainEducationType !== "high_school";

  return (
    <>
      <div className="col-md-12">
        <MainEducationStatus {...props} required />
      </div>
      {mainEducationType === "college" && (
        <div className="col-md-12">
          <IesEducationType
            {...props}
            required
            disabled={mainEducationType !== "college"}
          />
        </div>
      )}
      {showIesAndCourse && (
        <>
          <div className="col-md-12">
            <University {...props} required />
          </div>
          <div className="col-md-12">
            <Course {...props} required />
          </div>
        </>
      )}
      <IesPeriod {...props} required />
      <div className="col-md-12">
        <FormationDate {...props} required />
      </div>
    </>
  );
}


export default (props) => {
  const { isEnabled } = useFlipper();
  
  if (isEnabled("user_ats_candidature_education_level")){
    return <NewVersion {...props} />;
  } else {
    return <OldVersion {...props} />;
  }
}